var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-item-group',{attrs:{"mandatory":""}},[_c('v-row',_vm._l((_vm.options),function(option,key){return _c('v-col',{key:key,staticClass:"pa-2",attrs:{"cols":"12","md":_vm.md,"lg":_vm.lg,"sm":_vm.sm}},[_c('v-item',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var active = ref.active;
var toggle = ref.toggle;
return [_vm._t("default",null,{"option":option,"active":active,"toggle":toggle})]}}],null,true)})],1)}),1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }